<template>
  <div class="right">
    <div class="added_period added_period_box">
      <a class="btn btn_action btn_close" @click="onDeleteCustomLink"></a>
    <div :class="[key % 2 ? 'field_right' : 'field_left']" v-for="(languageCode, key) in deviceLanguages">
      <text-input
          :id="'customlinkname' + languageCode+'_'+id"
          v-model="content.title[languageCode]"
          :ref="'customlinkname' + languageCode"
          :disabled="disabled"
          @change="onChange"
      >
        {{getLanguageNameByCode(languageCode)}}
      </text-input>
    </div>
    <div class="field_left">
      <checkbox-input
          :id="'pairbypairingcode_'+id"
          v-model="content.open_in_new_window"
          ref="pairbypairingcode"
          :disabled="disabled"
          @change="onChange"
      >
        <translate class="translate">Otevírat v novém okně</translate>
      </checkbox-input>
    </div>
    <div class="field_full">
      <text-input
        :id="'customlinkurl_'+id"
        v-model="content.url"
        ref="customlinkurl"
        :disabled="disabled"
        :help-text="$gettext('Může obsahovat zástupné znaky {id_subscriber} a {language}')"
        @change="onChange"
    >
      <translate class="translate">URL</translate>
    </text-input></div>
    <div class="field_full">
      <text-input
          :id="'customlinksvgicon_'+id"
          v-model="content.icon"
          ref="customlinksvgicon"
          :disabled="disabled"
          :help-text="$gettext('Odkaz na ikonu ve formátu SVG')"
          @change="onChange"
      >
        <translate class="translate">Ikona</translate>
      </text-input></div>
  </div>
  </div>
</template>

<script>
import languages from "../../../mixins/languages";

export default {
  name: "CustomLink",
  mixins: [languages],
  props: {
    value: Object,
    disabled: Boolean,
    id: Number,
  },
  data(){
    return {
      content: this.value,
    }
  },
  methods: {
    onChange(){
      this.$emit('input', this.content);
    },
    onDeleteCustomLink(){
      this.$emit('deleteCustomLink', this.id)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/views/brands/forms/CustomLink.vue